import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';
import { Button } from '@els/els-react--button';
import { Flyout } from '@els/els-react--flyout';
import { LinkElement } from '@els/els-react--link-element';
import { Icon } from '@els/els-react--icon';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';

export const LEARN_MORE_LINK = 'https://service.elsevier.com/app/answers/detail/a_id/37789/supporthub/reaxys/kw/patent+family/';

function FlyoutContent() {
  return (
    <>
      <div>Patent family members are related patents that are covering the same or similar technical content</div>
      <LinkElement
        href={LEARN_MORE_LINK}
        isExternal
        iconSprite="UpRight"
        iconSize="xs"
        iconRight
        iconEmphasis
        className="view-full-patent-family__tooltip-link">
        Learn more
      </LinkElement>
    </>
  );
}

function ViewFullPatentFamily({ metadata, document, viewFullPatentFamily }) {
  const callback = useCallback(() => {
    viewFullPatentFamily({ document, metadata });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [document, metadata]);

  return (
    <div className="view-full-patent-family">
      <Button type="link" onClick={callback} className="e2e-view-full-patent-family">
        View full patent family
      </Button>
      <Flyout
        className="iew-fullpatent-family__flyout"
        flyout={<FlyoutContent />}
        shouldCloseOnESC
        placement="bottom-start"
        pointerType="primary">
        <button className="button button--link u-els-anchorize c-els-link c-els-link--with-icon c-els-anchorized-button" type="button">
          <Icon
            id={`view-full-patent-family-${uuid()}`}
            sprite="InformationOutlineCircle"
            size="xs"
            a11y={{ name: 'Manually curated', description: 'Manually curated patent' }}
          />
        </button>
      </Flyout>
    </div>
  );
}

ViewFullPatentFamily.propTypes = {
  metadata: MetadataPropTypesShape,
  document: PropTypes.object.isRequired,
  viewFullPatentFamily: PropTypes.func.isRequired,
};

export default ViewFullPatentFamily;
